module.exports = __webpack_public_path__ + "images/bdf759cdbe87c0ed783f7fa4f5e5460b.webp";